export default "__VITE_ASSET__BytR8CnZ__"